import "./Worksheet.scss";

import { type FC, useContext } from "react";
import { Doc } from "sharedb/lib/client";

import { PathType, WorksheetType } from "../../shared/types/worksheet";
import { DATA_PATH } from "../../shared/worksheets/constants";

import { Blocks } from "./Blocks";

import { DocViewContext } from "providers/DocViewProvider";
import { DoneProgress } from "worksheets/components/Aggregate/DoneProgress";
import { Worksheet } from "worksheets/views/Worksheet";

const RESPONSES_BASE_PATH: PathType = [DATA_PATH];

type WorksheetResponsesProps = {
  doc: Doc<WorksheetType>;
};

export const WorksheetResponses: FC<WorksheetResponsesProps> = ({ doc }) => {
  const { accessId, isFeaturing } = useContext(DocViewContext);

  if (!doc || !doc.data) return <div>Loading document</div>;

  if (accessId) {
    return <Worksheet doc={doc} />;
  }

  const shouldShowProgress = !accessId && !isFeaturing;

  return (
    <div className="worksheet-column-wrapper">
      {shouldShowProgress && (
        <div className="page-block-width">
          <DoneProgress className="page-block-width" />
        </div>
      )}

      {/* TODO: Something is very wrong about accessIdPath here */}
      <Blocks accessIdPath={RESPONSES_BASE_PATH} doc={doc} />
    </div>
  );
};
